import { jsx as _jsx } from "react/jsx-runtime";
import { usePointsPosition } from '../../hooks';
export function Polygon(props) {
    const { points: oldPoints, color, xAxis = 'x', yAxis = 'y', ...polylineProps } = props;
    const points = usePointsPosition({ points: oldPoints, xAxis, yAxis });
    return _jsx("polygon", { fill: color, points: points, ...polylineProps });
}
//# sourceMappingURL=Polygon.js.map